<template>
  <v-card rounded width="330px">
    <v-card-title class="px-6 py-2" :class="color">
      <v-icon :color="icon.color" size="16" class="me-3">
        {{ icon.name }}
      </v-icon>
      <p class="ma-0 pa-0 blue-grey--text text--darken-2 subtitle-2">
        {{ title }}
      </p>
    </v-card-title>
    <v-card-text class="px-6 py-5 d-flex flex-column justify-space-between">
      <div class="d-flex align-center mb-1" v-if="date">
        <p class="ma-0 pa-0 caption" style="width: 76px;">
          {{ $t('common.date.date') }}:
        </p>
        <div class="d-flex align-center">
          <v-icon size="18" color="blue-grey" class="me-1"
            >mdi-calendar-outline</v-icon
          >
          <p class="ma-0 pa-0 caption">{{ date }}</p>
        </div>
      </div>
      <div v-if="by" class="d-flex align-center">
        <p class="ma-0 pa-0 caption" style="min-width: 76px;">
          {{ $t('common.by') }}:
        </p>
        <User :account="by" avatarSize="22px" fontSize="12px" />
      </div>
      <div class="d-flex align-center mt-1" v-if="assignee">
        <p class="ma-0 pa-0 caption" style="min-width: 76px;">
          {{ $t('common.assignee_one') }}:
        </p>
        <User avatarSize="22px" fontSize="12px" :account="assignee" />
      </div>
    </v-card-text>
    <slot name="actions"></slot>
  </v-card>
</template>

<script>
import User from '@/components/Core/User.vue'

export default {
  name: 'ValidationCard',

  components: { User },

  props: {
    assignee: Object,
    by: Object,
    color: String,
    date: String,
    icon: Object,
    title: String,
  },
}
</script>
